( function () {
   
    'use strict';

    ( function ( $ ) {
        
        $('.accordion-title-main').click(function(j) {
    
            var dropDown = $(this).closest('.accordion-item').find('.accordion-content');
            $(this).closest('.accordion').find('.accordion-content').not(dropDown).slideUp();
            
            if ($(this).hasClass('active')) {
              $(this).removeClass('active');
            } else {
              $(this).closest('.accordion').find('.accordion-title-main.active').removeClass('active');
              $(this).addClass('active');
            }
            
            dropDown.stop(false, true).slideToggle();
            j.preventDefault();
        });

        $(' .accordion-btn a.acc-more').click(function () {
          $(this).find('.accordion').toggleClass('slidedown');
          $(this).parent().parent().toggleClass('active');
          $(this).toggleClass('add');
            if($(this).hasClass('add')){
              $(this).html('Read Less');
            }
            else{
              $(this).html('Read More');
            }
            return false;
        });
    } )( jQuery );
} )();

